import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { SUPPORT_EMAIL } from "@/i18n/content";
import { Mail } from "lucide-react";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-border bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="text-lg font-extrabold text-foreground">{t.footer.brand}</p>
            <p className="mt-1 text-sm text-muted-foreground">{t.brand.latin}</p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="footer-support-email-link"
              className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary underline-offset-4 hover:underline"
            >
              <Mail className="h-4 w-4" aria-hidden="true" />
              <span dir="ltr">{SUPPORT_EMAIL}</span>
            </a>
          </div>
          <nav className="flex flex-col gap-3" aria-label="Footer" data-testid="footer-nav">
            <Link to="/" data-testid="footer-support-link" className="text-sm font-semibold text-muted-foreground transition-colors duration-200 hover:text-primary">
              {t.footer.support}
            </Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm font-semibold text-muted-foreground transition-colors duration-200 hover:text-primary">
              {t.footer.privacy}
            </Link>
            <Link to="/about" data-testid="footer-about-link" className="text-sm font-semibold text-muted-foreground transition-colors duration-200 hover:text-primary">
              {t.footer.about}
            </Link>
          </nav>
        </div>
        <div className="mt-10 border-t border-border pt-6">
          <p className="text-sm text-muted-foreground" data-testid="footer-copyright">
            {t.footer.copyright} — {t.footer.brand}
          </p>
        </div>
      </div>
    </footer>
  );
};
